import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Paper,
  Switch,
  TextField,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { addBanner, getBanners, deleteBanner, updateBanner } from "../utils/bannerService";

const Banner = () => {
  const [file, setFile] = useState(null);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const fetchBanners = async () => {
    setLoading(true);
    try {
      const data = await getBanners();
      // Sort by position
      data.sort((a, b) => a.position - b.position);
      setBanners(data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Upload banner with name from file
  const handleAddBanner = async () => {
    if (!file) return;
    setUploading(true);
    try {
      await addBanner(file, {
        namaBanner: file.name,
        Active: true,
        position: banners.length + 1,
        link: "",
      });
      setFile(null);
      fetchBanners();
    } catch (err) {
      alert(err.message);
    }
    setUploading(false);
  };

  const handleToggleActive = async (id, current) => {
    await updateBanner(id, { Active: !current });
    fetchBanners();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Hapus banner ini?")) {
      await deleteBanner(id);
      fetchBanners();
    }
  };

  const handleLinkChange = async (id, value) => {
    await updateBanner(id, { link: value });
    fetchBanners();
  };

  // Drag & drop reorder
  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    const items = Array.from(banners);
    const [reordered] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reordered);

    // Update positions
    for (let i = 0; i < items.length; i++) {
      items[i].position = i + 1;
      await updateBanner(items[i].id, { position: i + 1 });
    }
    setBanners(items);
  };

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        CRUD Banner (Drag & Drop)
      </Typography>

      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <input type="file" onChange={handleFileChange} />
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddBanner}
          disabled={!file || uploading}
        >
          {uploading ? <CircularProgress size={20} /> : "Upload & Simpan"}
        </Button>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="banners">
            {(provided) => (
              <TableContainer component={Paper} {...provided.droppableProps} ref={provided.innerRef}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Preview</TableCell>
                      <TableCell>Nama Banner</TableCell>
                      <TableCell>Link</TableCell>
                      <TableCell>Active</TableCell>
                      <TableCell>Posisi</TableCell>
                      <TableCell>Aksi</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {banners.map((b, index) => (
                      <Draggable key={b.id} draggableId={b.id} index={index}>
                        {(provided) => (
                          <TableRow
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              <img src={b.imageUrl} alt={b.namaBanner} width={100} />
                            </TableCell>
                            <TableCell>{b.namaBanner}</TableCell>
                            <TableCell>
                              <TextField
                                value={b.link}
                                onChange={(e) => handleLinkChange(b.id, e.target.value)}
                                size="small"
                                fullWidth
                              />
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={b.Active}
                                onChange={() => handleToggleActive(b.id, b.Active)}
                                color="primary"
                              />
                            </TableCell>
                            <TableCell>{b.position}</TableCell>
                            <TableCell>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => handleDelete(b.id)}
                              >
                                Hapus
                              </Button>
                            </TableCell>
                          </TableRow>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </Box>
  );
};

export default Banner;
